module.exports = __webpack_public_path__ + "static/media/transfer.487acc54.svg";